import React, { useId, useState } from 'react';
import classnames from 'classnames';
import { RichText } from 'src/components/RichText/RichText';
import { Svg } from 'src/components/Svg/Svg';

import classes from './ProductDetail.scss';

type Props = {
    description: string;
};

export const ProductInfo: React.FC<Props> = ({ description }) => {
    const [isOpen, setIsOpen] = useState(true);
    const contentId = useId();

    return (
        <div className={classnames(classes.productInfo, { [classes.isOpen]: isOpen })}>
            <h2>
                <button
                    className={classes.productInfoToggle}
                    type="button"
                    onClick={() => setIsOpen(!isOpen)}
                    aria-expanded={isOpen}
                    aria-controls={contentId}
                >
                    Product Info
                    <span className={classes.arrow}>
                        <Svg name={isOpen ? 'arrow-up' : 'arrow-down'} />
                    </span>
                </button>
            </h2>
            <div id={contentId} inert={!isOpen}>
                <RichText content={description} />
            </div>
        </div>
    );
};
